import React, { Component } from 'react';
import Logo from '../../../assets/images/icons/hatchef.svg';
import '../../../assets/css/custom.css';
import {
    Button,
    Modal,
    ModalHeader,
    ModalBody,
    ModalFooter,
    Row,
    Col
} from 'reactstrap';
import "react-responsive-carousel/lib/styles/carousel.min.css";
import { Carousel } from 'react-responsive-carousel';

import PlusIcon from '../../../assets/images/icons/plus.svg';
import InfoIcon from '../../../assets/images/icons/info.svg';
import WorldIcon from '../../../assets/images/icons/world.svg';
import PlayIcon from '../../../assets/images/icons/play.svg';
import Facebook from '../../../assets/images/icons/facebook.svg';
import Whatsapp from '../../../assets/images/icons/whatsapp.svg';
import SpecsIcon from '../../../assets/images/icons/specs.svg';
import PromoIcon from '../../../assets/images/icons/promo.svg';

import { serverResponse } from '../../../util/fakeServer';
import ReactGA from 'react-ga';
import { gaEventLabel } from '../../../settings/gaConfig';
import { isMobile } from 'react-device-detect';

export default class HatChefMarker extends Component {

    componentDidMount() {
        if (serverResponse.config.ga_active) {
            ReactGA.initialize(serverResponse.config.ga_tracking_id);
        }
    }

    setModal = (swipe) => {
        //TODO
        //axios per l'incremento del counter di visualizzazioni della modal hatchef
        /*
        if(this.state.modal === false){
            axios({
            method: 'post',
            url: '',
            headers: {
            },
        })
            .then(res => {
 
            }).catch(error => {
                //console.log(error);
            });
        }*/
        this.props.setSwipe(swipe);
        //this.props.leafletSwipe();
        this.setState({ modal: !this.state.modal });

    }

    state = {
        modal: false,
    }

    shareOnFacebook = () => {
        let imageSrc = serverResponse.config.serverPath + this.props.info.images[this.props.info.images.length - 1].image_file;
        window.open("https://www.facebook.com/sharer/sharer.php?u=" + encodeURIComponent(imageSrc), '_blank', 'location=yes,height=570,width=520,scrollbars=yes,status=yes');
    }

    shareOnWhatsapp = () => {
        let imageSrc = serverResponse.config.serverPath + this.props.info.images[this.props.info.images.length - 1].image_file;
        //window.location = "http://api.whatsapp.com/send?text=" + serverResponse.config.shareProductSentence + '    ' + encodeURIComponent(imageSrc);
        window.open("http://api.whatsapp.com/send?text=" + serverResponse.config.shareProductSentence + '    ' + encodeURIComponent(imageSrc), '_blank', 'location=yes,height=570,width=520,scrollbars=yes,status=yes');
    }

    render() {

        const markers = this.props.info.markers.map((element, key) => {
            switch (element.type) {
                case "plus": {
                    return <img key={key} src={PlusIcon} className="icon-marker" alt="plus" onClick={() => {
                        this.props.navMarkers("plus");
                        this.setModal(false);
                    }} />
                }
                case "info": {
                    return <img key={key} src={InfoIcon} className="icon-marker" alt="Info" onClick={() => {
                        this.props.navMarkers("info");
                        this.setModal(false);
                    }} />
                }
                case "world": {
                    return <img key={key} src={WorldIcon} className="icon-marker" alt="World" onClick={() => {
                        this.props.navMarkers("world");
                        this.setModal(false);
                    }} />
                }
                case "hat-chef": {
                    return null
                }
                case "play": {
                    return <img key={key} src={PlayIcon} className="icon-marker" alt="play" onClick={() => {
                        this.props.navMarkers("play");
                        this.setModal(false);
                    }} />
                }
                case "specs": {
                    return <img key={key} src={SpecsIcon} className="icon-marker" alt="specs" onClick={() => {
                        this.props.navMarkers("specs");
                        this.setModal(false);
                    }} />
                }
                case "promo": {
                    return <img key={key} src={PromoIcon} className="icon-marker-promo" alt="promo" onClick={() => { this.props.navMarkers("promo"); this.setModal(false) }} />
                }
                default: return null
            }
        });

        let carousel = undefined;
        if (this.props.markerInfo.data.img.length > 1) {
            carousel = <Carousel
                swipeable={true}
                emulateTouch={true}
                infiniteLoop={true}
                showStatus={false}>

                {this.props.markerInfo.data.img.map((element, key) =>
                    <img key={key} src={process.env.PUBLIC_URL + element} alt="img" />
                )}

            </Carousel>
        } else {
            carousel = <img style={{ width: "100%" }} src={process.env.PUBLIC_URL + this.props.markerInfo.data.img} alt="img" />
        }
        /*const listImages = this.props.markerInfo.data.img.map((element, key) =>
            <img key={key} src={element} alt="img" />
        );*/

        const ingredients = this.props.markerInfo.data.ingredients.split(", ");
        const listIngredients = ingredients.map((element, key) =>
            <li key={key}>{element}</li>
        );

        return (
            <div className="marker vertical" type="hatchef" style={{ display: this.props.info.hidden_price ? "none" : "" }}>
                <img id={"hatchef-" + this.props.info.item_id} src={Logo} className="icon-marker" style={{ display: (isMobile ? "none" : "") }} alt="HatChef" onClick={() => {
                    this.setModal(false);
                    if (serverResponse.config.ga_active) {
                        ReactGA.event({
                            category: serverResponse.config.release_id,
                            action: gaEventLabel.open_product_recipe,
                            label: String(this.props.info.item_id)
                        });
                    }
                }} />
                {isMobile &&
                    <img src={Logo} className="icon-marker" alt="HatChef" onClick={() => {
                        this.props.navMarkers("plus");
                    }} />
                }
                <Modal
                    isOpen={this.state.modal}
                    toggle={() => this.setModal(true)}
                    size="lg"
                >
                    <ModalHeader toggle={() => this.setModal(true)}>Ricetta</ModalHeader>
                    <ModalBody>
                        <Row style={{ marginBottom: "16px" }}>
                            <Col style={{ /*display: "flex", */height: "30px" }}>
                                <div className="markers-container" style={{ width: "100%" }}>
                                    <div className="vertical">{markers}</div>
                                    <img src={Facebook} className="share-icon" style={{ marginLeft: "auto" }} alt="facebook" onClick={() => this.shareOnFacebook()} />
                                    <img src={Whatsapp} className="share-icon" alt="whatsapp" onClick={() => this.shareOnWhatsapp()} />
                                </div>
                            </Col>
                        </Row>
                        <Row>
                            <Col>
                                <h4 style={{ textTransform: "uppercase", marginBottom: "15px" }}>{this.props.markerInfo.title}</h4>
                            </Col>
                        </Row>
                        <Row>
                            <Col xs="12" sm="6" md="6" xl="6" style={{ marginBottom: "15px" }}>
                                {carousel}
                            </Col>
                            <Col xs="12" sm="6" md="6" xl="6">
                                <h6 style={{ marginTop: "10px", fontWeight: "bold" }}>INGREDIENTI</h6>
                                <ul>
                                    {listIngredients}
                                </ul>
                            </Col>
                        </Row>

                        <Row>
                            <Col >
                                <h6 style={{ marginTop: "10px", fontWeight: "bold" }}>Procedimento</h6>
                                <p>{this.props.markerInfo.data.recipe}</p>
                            </Col>
                        </Row>
                    </ModalBody>
                    <ModalFooter>
                        <Button color="primary" onClick={() => this.setModal(true)}>
                            Chiudi
                    </Button>
                    </ModalFooter>
                </Modal>
            </div>
        );
    }
} 